import React from "react"
import { Icon, Modal } from "@ncs/web-legos"
import { css } from "@emotion/react"
import { useCustomerPaymentMethods } from "@ncs/ncs-api/portal-apps"

interface VerificationSuccessfulProps {
	isOpen: boolean
	onClose: () => void
}

export const VerificationSuccessful: React.FC<VerificationSuccessfulProps> = ({
	isOpen,
	onClose,
}) => {
	const [customerPaymentMethods] = useCustomerPaymentMethods()
	const bankAccounts = customerPaymentMethods?.bankAccounts ?? []
	const lastBankAccount = bankAccounts[bankAccounts.length - 1] ?? null

	return (
		<Modal
			showCloseButton={false}
			isOpen={isOpen}
			onClose={onClose}
			rightButtons={{
				buttonText: "CLOSE",
				variant: "clear",
				onClick: onClose,
			}}
		>
			<div css={container}>
				<span>
					<Icon icon="check" fontSize={2} color="white" />
				</span>
				<h3>Verification Completed!</h3>
				<p>
					Your account ending in ...{lastBankAccount?.accountNumberLast4 ?? "****"} has
					been verified.
				</p>
			</div>
		</Modal>
	)
}

const container = css`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;

	> span {
		background-color: #10b981;
		padding: 1rem;
		border-radius: 2rem;
		width: 3rem;
		height: 3rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	h3 {
		color: #111827;
		text-align: center;
		font-size: 1.5rem;
		font-weight: 700;
	}

	h4 {
		color: #1d4ed8;
		font-size: 1rem;
		margin-bottom: 0.625rem;
		font-weight: 600;
	}

	p {
		color: #111827;
		text-align: center;
		font-size: 1rem;
		font-weight: 400;
		margin: 1rem 0 2rem 0;
	}
`
